// extracted by mini-css-extract-plugin
export default {"root":"Terms_root__xch5q","container":"Terms_container__+Wzko","header":"Terms_header__FKrgv","terms":"Terms_terms__SzO+m","terms_sep":"Terms_terms_sep__TvHTq"};